import React from 'react';
import { motion } from 'framer-motion';
export function FinalClosingSection() {
  const handleCheckoutClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const href = e.currentTarget.href;
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'Protocolo Silencio TTPM',
        content_ids: ['protocolo-silencio-ttpm'],
        content_type: 'product',
        value: 11.99,
        currency: 'USD'
      });
    }
    setTimeout(() => {
      window.location.href = href;
    }, 300);
  };
  return <section className="py-20 md:py-32 px-5 md:px-8 bg-[#0B1224] border-t border-[#15203B]" data-id="element-168">
      <div className="max-w-3xl mx-auto text-center" data-id="element-169">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-170">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-8" data-id="element-171">
            Esta noche puedes hacer algo diferente
          </h2>

          <div className="text-gray-300 text-lg md:text-xl leading-relaxed space-y-4 mb-12" data-id="element-172">
            <p data-id="element-173">
              Puedes volver a acostarte esperando que el zumbido no aparezca.
            </p>
            <p data-id="element-174">
              O puedes tener una rutina clara para responder de otra forma
              cuando aparezca.
            </p>
            <p data-id="element-175">
              No con miedo. No con frustración. No peleando contra tu mente.
            </p>
            <p className="text-white font-medium" data-id="element-176">
              Sino guiando tu atención, calmando tu cuerpo y enseñándole a tu
              cerebro que ese sonido ya no necesita ocupar toda la noche.
            </p>
          </div>

          <a href="https://pay.hotmart.com/M105215372D?checkoutMode=10" onClick={handleCheckoutClick} className="inline-flex bg-[#F6C65B] hover:bg-[#FFD680] text-[#070B16] font-bold text-xl md:text-2xl px-8 py-5 rounded-xl transition-all duration-300 shadow-[0_0_30px_rgba(246,198,91,0.5)] transform hover:scale-105 active:scale-95 w-full md:w-auto items-center justify-center" data-id="element-177">
            Quiero el Protocolo Silencio TTPM™ por $11.99
          </a>
        </motion.div>
      </div>
    </section>;
}